<template>
  <ls-table-layout>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleAddLine" type="primary">新建</a-button>
      <a-button @click="handleSave" :loading="saveLoading" type="primary" :disabled="selectedRows.length === 0">保存</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="indexId"
          :scroll="{ x: 2800, fixScreen: true, extraHeight: 0 }"
          @selectedRowChange="selectedRowChange"
        >
          <span slot="wipEntityNameTitle">
            <i class="toRequired">*</i>零部件工单号
          </span>
          <span slot="sourceSublibraryTitle">
            <i class="toRequired">*</i>来源子库
          </span>
          <span slot="sourceLocationTitle">
            <i class="toRequired">*</i>来源货位
          </span>
          <span slot="targetSublibraryTitle">
            <i class="toRequired">*</i>目标子库
          </span>
          <span slot="targetLocationTitle">
            <i class="toRequired">*</i>目标货位
          </span>
          <span slot="quantityTitle">
            <i class="toRequired">*</i>数量
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record, index }">
            <div :key="item.dataIndex">
              <span v-if="item.type === 'select'">
                <global-select
                  :value.sync="record[item.dataIndex]"
                  :selectType="item.selectType ? item.selectType : 'select'"
                  :focusGet="item.focusGet ? item.focusGet : false"
                  :requestApi="item.requestApi"
                  :selectData="setArray(item.dataList)"
                  :selectItem="{ value: item.value, label: item.label }"
                  :searchParam="item.searchParam ? item.searchParam : ''"
                  :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
                  :allowClear="false"
                  size="small"
                  :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                  @change="selectChange(record, item.dataIndex, index)"
                />
              </span>
              <span v-else-if="item.type === 'input'">
                <a-input v-model="record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <a-input-number v-model="record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiInvCallRequestLinesWipEntityNameBox,
  apiInvCallRequestLinesWipEntityNameToData,
  apiInvCallRequestLinesStockTransferToData,
  apiInvCallRequestLinesStockTransfer
} from '@/api/mes/partsHandover/partsTransfer'
export default {
  name: 'PartsTransfer', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {},
  data () {
    return {
      tableProps: {
        requestApi: "",
        pageCurrent: true
      },
      // 查询参数
      queryParams: {},
      // 表格字段
      columns: [
        {
          title: '组织',
          fixed: 'left',
          dataIndex: 'organizationName',
          align: 'center'
        },
        {
          // title: '零部件工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          scopedSlots: { customRender: 'wipEntityName', title: "wipEntityNameTitle" },
          width: 180,
          type: "select",
          dataList: 'wipEntityNameList',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '派工单号',
          dataIndex: 'dispatchNumber',
          align: 'center',
          scopedSlots: { customRender: 'dispatchNumber' },
          type: "input"
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'primaryUom',
          align: 'center'
        },
        {
          // title: '来源子库',
          dataIndex: 'sourceSublibrary',
          align: 'center',
          scopedSlots: { customRender: 'sourceSublibrary', title: "sourceSublibraryTitle" },
          width: 180,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "warehouseCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoSublibraryBox',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '来源货位',
          dataIndex: 'sourceLocation',
          align: 'center',
          scopedSlots: { customRender: 'sourceLocation', title: "sourceLocationTitle" },
          width: 180,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "locationCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoGoodsAllocationBox',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '现有量',
          dataIndex: 'onhandQuantity',
          align: 'center'
        },
        {
          title: '可用量',
          dataIndex: 'availableQuantity',
          align: 'center'
        },
        {
          // title: '目标子库',
          dataIndex: 'targetSublibrary',
          align: 'center',
          scopedSlots: { customRender: 'targetSublibrary', title: "targetSublibraryTitle" },
          width: 180,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "warehouseCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoSublibraryBox',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '目标货位',
          dataIndex: 'targetLocation',
          align: 'center',
          scopedSlots: { customRender: 'targetLocation', title: "targetLocationTitle" },
          width: 180,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "locationCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoGoodsAllocationBox',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '批次号',
          dataIndex: 'lotNumber',
          align: 'center'
        },
        {
          // title: '数量',
          dataIndex: 'quantity',
          align: 'center',
          scopedSlots: { customRender: 'quantity', title: "quantityTitle" },
          type: "inputNumber"
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          align: 'center',
          scopedSlots: { customRender: 'remarks' },
          type: "input"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
          type: "text"
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      wipEntityNameList: [], // 零部件工单号
      saveLoading: false
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.getWipEntityNameList()
  },
  mounted () {},
  methods: {
    // 新增行
    handleAddLine () {
      const arr = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        desOrganizationCode: "",
        wipEntityName: "",
        dispatchNumber: "",
        itemCode: "",
        specification: "",
        primaryUom: "",
        sourceSublibrary: "",
        sourceLocation: "",
        onhandQuantity: "",
        availableQuantity: "",
        targetSublibrary: "",
        targetLocation: "",
        lotNumber: "",
        quantity: "",
        remarks: "",
        createName: "",
        createTime: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.$refs.dataTable.myDataSource = arr
    },
    // 保存
    handleSave () {
      let flag = false
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (!this.selectedRows[i].wipEntityName ||
        !this.selectedRows[i].sourceSublibrary ||
        !this.selectedRows[i].sourceLocation ||
        !this.selectedRows[i].targetSublibrary ||
        !this.selectedRows[i].targetLocation) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        if (!this.selectedRows[i].quantity || Number(this.selectedRows[i].quantity) <= 0) {
          this.$message.warning('数量 不能为空且需大于0')
        }
        if (Number(this.selectedRows[i].quantity) > Number(this.selectedRows[i].availableQuantity)) {
          this.$message.warning('调拨数量不能超过库存可用量')
        }
      }
      if (flag) {
        return false
      }
      this.saveLoading = true
      apiInvCallRequestLinesStockTransfer({ list: this.selectedRows }).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(response.msg)
        }
        this.saveLoading = false
      }).catch(e => {
        this.saveLoading = false
      })
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "sourceSublibrary" || dataIndex === "targetSublibrary") {
        return { organizationCode: this.organizationCodeOrigin }
      }
      if (dataIndex === "sourceLocation") {
        return { subinventoryCode: record.sourceSublibrary }
      }
      if (dataIndex === "targetLocation") {
        return { subinventoryCode: record.targetSublibrary }
      }
    },
    setArray (arr) {
      return this[arr]
    },
    selectChange (record, dataIndex, index) {
      if (dataIndex === "wipEntityName") {
        apiInvCallRequestLinesWipEntityNameToData({ wipEntityName: record.wipEntityName }).then(res => {
          const arr = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
          arr[index] = Object.assign(record, res.data)
          this.$refs.dataTable.myDataSource = arr
        })
      }
      if (dataIndex === "sourceSublibrary" || dataIndex === "sourceLocation") {
        if (record.sourceSublibrary && record.sourceLocation) {
          apiInvCallRequestLinesStockTransferToData({ lotNumber: record.lotNumber, sourceSublibrary: record.sourceSublibrary, sourceLocation: record.sourceLocation }).then(ress => {
            const arr = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
            arr[index] = Object.assign(record, ress.data)
            this.$refs.dataTable.myDataSource = arr
          })
        }
      }
    },
    // 零部件工单号
    getWipEntityNameList () {
      apiInvCallRequestLinesWipEntityNameBox().then(res => {
        if (res.rows && res.rows.length > 0) {
          this.wipEntityNameList = res.rows
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.page-header-content{
  /deep/.ant-select{
    width: 150px;
  }
}
/deep/.ant-calendar-picker{
  width: 100% !important
}
/deep/.ant-form-item-control-wrapper{
  width: 25% !important
}
/deep/.ant-pagination{
  display: none;
}
</style>
